import { HttpClient } from '@adapters/HttpClient';
import type {
  CreateOrderRequest,
  CreateOrderResponse,
  UpdateOrderRequest,
  UpdateOrderResponse,
} from './types';

export class OrdersApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async createOrder(
    orderData: CreateOrderRequest
  ): Promise<CreateOrderResponse> {
    try {
      const response = await this.httpClient.post<any>('/orders', orderData);

      // Si la respuesta es exitosa
      return {
        success: true,
        message: response.message || 'Orden creada exitosamente',
        order_id: response.id || response.order_id,
      };
    } catch (error: any) {
      // Retornar el error tal cual para que el hook lo maneje con el traductor
      throw error;
    }
  }

  async updateOrder(
    orderId: number,
    orderData: UpdateOrderRequest
  ): Promise<UpdateOrderResponse> {
    try {
      const response = await this.httpClient.put<any>(
        `/orders/${orderId}`,
        orderData
      );

      // Si la respuesta es exitosa
      return {
        success: true,
        message: response.message || 'Orden actualizada exitosamente',
        order_id: response.id || response.order_id || orderId,
      };
    } catch (error: any) {
      // Retornar el error tal cual para que el hook lo maneje con el traductor
      throw error;
    }
  }
}
